import { render, staticRenderFns } from "./AddAboutClientsModal.vue?vue&type=template&id=68764c55"
import script from "./AddAboutClientsModal.vue?vue&type=script&lang=js"
export * from "./AddAboutClientsModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports